import axios from 'axios';

// Timeout global: sin esto, una petición colgada (mala señal del cliente,
// servidor lento) se queda pendiente indefinidamente sin error ni feedback.
axios.defaults.timeout = 15000;

axios.interceptors.response.use(
  response => {

    return response;
  },
  error => {
    // OJO: antes esta función no relanzaba el error (ni "return
    // Promise.reject(error)" ni throw), así que CUALQUIER error de
    // CUALQUIER llamada de toda la app quedaba convertido en una promesa
    // resuelta con "undefined" -- el .then(response => response.data) de
    // cada método de este archivo tronaba con un TypeError genérico
    // ("Cannot read properties of undefined"), perdiendo el status code y
    // el mensaje real del backend en el camino. Por eso los .catch() de
    // este archivo nunca veían el error verdadero.
    if (error && error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
    return Promise.reject(error);
  }
);

const API_URL = process.env.REACT_APP_URL + 'api/';
class ApiService {
  getCategories(access_token, template) {
    return axios
      .get(API_URL + 'categories/template/' + template, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getProducts(access_token, id_category) {
    return axios
      .get(API_URL + 'products/categories/' + id_category, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getProductDetails(access_token, id) {
    return axios
      .get(API_URL + 'products/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  postItemToCart(access_token, data) {
    return axios
      .post(API_URL + 'cart', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        /*var cartData = JSON.parse(localStorage.getItem('cart')) ? JSON.parse(localStorage.getItem('cart')): [];
        var dataArray = []; 
        
        if(cartData){
          cartData.push(response.data.data);
        }else{
          dataArray[0] = response.data.data;
          cartData = dataArray;
        }*/

        //localStorage.setItem("cart", JSON.stringify(cartData));
        return response.data;
      })
      .catch(error => {
      });
  }

  getCartUser(access_token, id_user) {
    return axios
      .get(API_URL + 'cart/' + id_user, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        let userData = JSON.parse(localStorage.getItem('user'));
        userData.token_order = response.data.token_order;
        localStorage.setItem('user', JSON.stringify(userData));
        //localStorage.setItem("cart", JSON.stringify(response.data.data));
        return response.data;
      })
      .catch(error => {
      });
  }

  deleteCartUser(access_token, id) {
    return axios
      .delete(API_URL + 'cart/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        /*let cartData = JSON.parse(localStorage.getItem('cart')) ? JSON.parse(localStorage.getItem('cart')): [];
        var data = [];
        if(cartData){
          cartData.forEach( (element,n)  => {
            if(element.id != response.data.data.id){
              data[n] = element;
            }
          });
        }

        localStorage.setItem("cart", JSON.stringify(data));*/
        return response.data;
      })
      .catch(error => {
      });
  }

  updateCartUser(access_token, data) {
    return axios
      .put(API_URL + 'cart', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        /*let cartData = JSON.parse(localStorage.getItem('cart')) ? JSON.parse(localStorage.getItem('cart')): [];
        var data = [];
        if(cartData){
          cartData.forEach( (element,n)  => {
            if(element.id == response.data.data.id){
              data[n] = response.data.data;
            }else{
              data[n] = element;
            }
          });
        }

        localStorage.setItem("cart", JSON.stringify(data));*/
        return response.data;
      })
      .catch(error => {
      });
  }

  postPurchase(access_token, data) {
    return axios
      .post(API_URL + 'purchase/create', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        //localStorage.setItem("cart", JSON.stringify([]));
        return response.data;
      })
      .catch(error => {
      });
  }

  postCancelPurchase(access_token, data) {
    return axios
      .post(API_URL + 'purchase/cancel', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        //localStorage.setItem("cart", JSON.stringify([]));
        return response.data;
      })
      .catch(error => {
      });
  }

  sendPhone(data) {
    return axios
      .post(API_URL + 'signinphone', data, {
        headers: {
          //'Authorization': `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getReferredOrders(access_token, cart_token, id_ambassador) {
    let body = {
      id: id_ambassador,
      token: cart_token
    };
    return axios
      .post(API_URL + 'purchase/user', body, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        //localStorage.setItem("referred_orders", JSON.stringify(response.data.data));

        let userData = JSON.parse(localStorage.getItem('user'));
        userData.token_order = response.data.token_order;
        localStorage.setItem('user', JSON.stringify(userData));

        return response.data;
      })
      .catch(error => {
      });
  }

  postUser(access_token, formData) {
    return axios
      .post(API_URL + 'users', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  placesAutocomplete(access_token, query) {
    return axios
      .get(API_URL + 'addresses/places-autocomplete', {
        params: { query },
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then(response => response.data.suggestions || [])
      .catch(() => []);
  }

  placeDetails(access_token, place_id) {
    return axios
      .get(API_URL + 'addresses/place-details', {
        params: { place_id },
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then(response => response.data)
      .catch(() => null);
  }

  reverseGeocode(access_token, lat, lng) {
    return axios
      .get(API_URL + 'addresses/reverse-geocode', {
        params: { lat, lng },
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then(response => response.data || null)
      .catch(() => null);
  }

  postAddressUser(access_token, formData) {
    return axios
      .post(API_URL + 'addresses', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getUserDetails(access_token, id) {
    return axios
      .get(API_URL + 'users', {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getUserAddresses(access_token, id) {
    return axios
      .get(API_URL + 'addresses/ambassador', {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getUserReferreds(access_token, id) {
    return axios
      .get(API_URL + 'users/refered/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  deletetUserAddress(access_token, id_ambassador, id) {
    return axios
      .delete(API_URL + 'addresses/ambassador/' + id_ambassador + '/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  updateAddressUser(access_token, data) {
    return axios
      .put(API_URL + 'addresses/ambassador', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  updatePurchase(access_token, data) {
    return axios
      .put(API_URL + 'purchase/checkout ', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  // Validación previa al comprobante: el servidor corre el mismo checkout sin
  // crear nada. null si no se pudo validar (red, o backend sin esta ruta).
  validatePurchaseUser(access_token, data) {
    return axios
      .post(API_URL + 'purchase/user/checkout/validate', data, {
        // Si el servidor tarda, no se deja al cliente esperando: se responde
        // null y el modal se abre como antes (la compra real valida todo).
        timeout: 15000,
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return null;
      });
  }

  updatePurchaseUser(access_token, data) {
    return axios
      .post(API_URL + 'purchase/user/checkout', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getPickupWindows(access_token, id, flag) {
    return axios
      .get(API_URL + 'pickup-windows/' + id + '/' + flag, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getCategParents(access_token, id) {
    return axios
      .get(API_URL + 'categories/parent/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getUserHistoryOrders(access_token, id) {
    return axios
      .get(API_URL + 'purchase/history/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getUserHistoryOrdersReferidos(access_token, id) {
    return axios
      .get(API_URL + 'purchase/history-referidos/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getDistricts(access_token) {
    return axios
      .get(API_URL + 'districts', {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  updateRefered(access_token, data) {
    return axios
      .put(API_URL + 'users/refered', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  updateUserData(access_token, data) {
    return axios
      .put(API_URL + 'users/data', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  updateUserDataCampaign(access_token, data) {
    return axios
      .put(API_URL + 'users/datacampaign', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        return response.data;
      });
  }

  updateUserPassword(access_token, data) {
    return axios
      .put(API_URL + 'users/password', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  deletetUserRefered(access_token, id_ambassador, id) {
    return axios
      .delete(API_URL + 'users/refered/' + id_ambassador + '/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  addAddressData(access_token, data) {
    return axios
      .post(API_URL + 'addresses/temporal', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  updateAddressData(access_token, data) {
    return axios
      .put(API_URL + 'addresses/temporal', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  updateAddressDataCampaign(access_token, data) {
    return axios
      .put(API_URL + 'addresses/campaign', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        return response.data;
      });
  }

  getProfileCampaignStatus(access_token) {
    return axios
      .get(API_URL + 'campaign/profile-update', {
        headers: { Authorization: `Bearer ${access_token}` }
      })
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  }

  postProfileCampaignShown(access_token) {
    return axios
      .post(
        API_URL + 'campaign/profile-update/shown',
        {},
        {
          headers: { Authorization: `Bearer ${access_token}` }
        }
      )
      .then(response => response.data)
  }

  postProfileCampaignComplete(access_token) {
    return axios
      .post(
        API_URL + 'campaign/profile-update/complete',
        {},
        {
          headers: { Authorization: `Bearer ${access_token}` }
        }
      )
      .then(response => response.data)
  }

  postProfileCampaignError(access_token, payload) {
    return axios
      .post(
        API_URL + 'campaign/profile-update/error',
        payload,
        {
          headers: { Authorization: `Bearer ${access_token}` }
        }
      )
      .then(response => response.data)
  }

  getCheckoutSettings(access_token) {
    return axios
      .get(API_URL + 'settings-checkout', {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getBanners(access_token) {
    return axios
      .get(API_URL + 'banners', {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  checkOpen(access_token) {
    return axios
      .get(API_URL + 'check-open', {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  checkOpenWeb() {
    return axios
      .get(API_URL + 'check-open-web', {})
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getSUmDebt(access_token) {
    return axios
      .get(API_URL + 'sum-debt', {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getDebts(access_token) {
    return axios
      .get(API_URL + 'debts', {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  async uploadVoucher(access_token, data) {
    return await axios
      .post(API_URL + 'debts', data, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      });
  }

  async uploadVoucherTemp(access_token, data) {
    return await axios
      .post(API_URL + 'upload-voucher', data, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      });
  }

  validateCode(access_token, data) {
    return axios
      .post(API_URL + 'validate-code', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getMoreProducts(access_token, params) {
    return axios
      .get(API_URL + 'more-products', {
        headers: {
          Authorization: `Bearer ${access_token}`
        },
        params: params
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getNewCheckoutAccess(access_token) {
    return axios
      .get(API_URL + 'new-checkout-access', {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getCountMoreProducts(access_token, params) {
    return axios
      .get(API_URL + 'count-moreproducts', {
        headers: {
          Authorization: `Bearer ${access_token}`
        },
        params: params
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  }

  getPayDebts(id = null) {
    const url = id ? `${API_URL}paydebts/${id}` : `${API_URL}paydebts`;

    // Antes tragaba el error acá (catch vacío) y devolvía undefined tanto
    // para un link inválido como para un timeout de red — el caller no
    // podía distinguirlos. Ahora se deja propagar para que quien llama
    // pueda ver error.response.status y decidir qué mostrar.
    return axios.get(url).then(response => response.data);
  }

  async uploadVoucherPayDebt(data) {
    return await axios
      .post(API_URL + 'uploadVoucherPayDebt', data)
      .then(response => {
        return response.data;
      });
  }
}

export default new ApiService();
